import * as React from "react";
import BeatLoader from "react-spinners/BeatLoader";
import { theme } from "../../theme";

interface Props {
  color?: string;
}

const SmallLoadingSpinner: React.FC<Props> = ({ color }) => {
  return <BeatLoader color={color ?? theme.colors.primary} size={15} />;
};

export default SmallLoadingSpinner;
